<template>
  <div
    class="card_list card_list_small"
    :class="{
      warnShadow: msg.isflicker,
      checkCss: msg.ischecked,
      'eventNone grayImage': msg.iseventNone,
      hiden: !!msg.isHidenbox,
    }"
    @click="cardset"
  >
    <!-- :class="[msg.ischecked ? 'checkCss' : '']" -->
    <!-- <div :class="[msg.isflicker ? 'warnShadow' : '']" class="shadow_box"></div> -->

    <div class="card_header">
      <div
        v-if="msg.ProtocolTypeList && msg.ProtocolTypeList.length === 1"
        class="card_badge"
        :class="
          msg.ProtocolTypeList == 1
            ? 'bgcolor1'
            : msg.ProtocolType == 2
              ? 'bgcolor2'
              : msg.ProtocolType == 3
                ? 'bgcolor3'
                : msg.ProtocolType == 4
                  ? 'bgcolor4'
                  : msg.ProtocolType == 5
                    ? 'bgcolor5'
                    : msg.ProtocolType == 6
                      ? 'bgcolor6'
                      : msg.ProtocolType == 7
                        ? 'bgcolor7'
                        : ''
        "
      >
        <i :title="msg.ProtocolTypeList && msg.ProtocolTypeList[0].Name">{{ msg.ProtocolTypeList[0].Name }}</i>
      </div>
      <div
        v-if="msg.ProtocolTypeList && msg.ProtocolTypeList.length >= 2"
        class="card_badge"
        :class="
          msg.ProtocolTypeList == 1
            ? 'bgcolor1'
            : msg.ProtocolType == 2
              ? 'bgcolor2'
              : msg.ProtocolType == 3
                ? 'bgcolor3'
                : msg.ProtocolType == 4
                  ? 'bgcolor4'
                  : msg.ProtocolType == 5
                    ? 'bgcolor5'
                    : msg.ProtocolType == 6
                      ? 'bgcolor6'
                      : msg.ProtocolType == 7
                        ? 'bgcolor7'
                        : ''
        "
      >
        <i title="MIX">MIX</i>
      </div>
      <el-checkbox
        v-if="extraProps.is_check"
        v-model="msg.ischecked"
        :class="extraProps.isradio ? 'check_one' : 'card_check'"
        :disabled="msg.isdisabled"
        class="card_check"
        @change="removeTree"
      />
      <!-- <div class="multipleCheck" v-if="msg.multipleDialogGroup">
        <span>{{ $t('devicecard.selected') }}</span>
      </div> -->

      <slot name="delete" />
      <div class="card_header_msg" :class="msg.IsBind ? 'real' : 'fake'">
        <div class="card_left">
          <!-- 项目图片 -->
          <!-- <template v-if="msg.IconUrl">
									<img class="card_img" :src="'/static/device/icon/' + msg.IconUrl" />
								</template>
								<template v-else>
									<img class="card_img" src="../../assets/img/d_f2.png" />
								</template> -->
          <!-- <img class="card_img" :src="getClassSkuImage(msg,'on')" /> -->

          <img v-if="$store.state.isLocalServer" class="card_img" :src="getClassSkuImage(msg, 'on')">
          <img v-else class="card_img" :src="getImgUrlState(msg, 'on')">

          <!-- <template v-if="msg.StatusCode!=null&&msg.StatusCode!=''">
										<img :title="$t('devicecard.offline')" v-if="!msg.IsOnline" class="link_img" src="../../assets/img/icon_type26.png" />
										<img :title="$t('devicecard.online')" v-else-if="msg.IsOnline&&msg.StatusCode.substring(0,4)=='0x00'" class="link_img" src="../../assets/img/icon_type25.png" />
										<img :title="$t('devicecard.callpolice')" v-else-if="msg.IsOnline&&msg.StatusCode.substring(0,4)=='0x01'" class="link_img" src="../../assets/img/icon_type02.png" />
										<img :title="$t('devicecard.malfunction')" v-else-if="msg.IsOnline&&msg.StatusCode.substring(0,4)=='0x02'" class="link_img" src="../../assets/img/icon_type01.png" />
										<img :title="$t('devicecard.lifeto')" v-else-if="msg.IsOnline&&msg.StatusCode.substring(0,4)=='0x03'" class="link_img" src="../../assets/img/icon_type03.png" />
									</template>
									<template v-else>
										<img :title="$t('devicecard.offline')" v-if="!msg.IsOnline" class="link_img" src="../../assets/img/icon_type26.png" />
										<img :title="$t('devicecard.online')" v-else class="link_img" src="../../assets/img/icon_type25.png" />
									</template> -->

          <template v-for="(model, kindex) in msg.StatusInfo">
            <template v-if="model.StatusType == '0x0000' && model.Value1 != '0x0000' && model.Value1 != '0x0001'">
              <template v-if="model.Value1 != '--' && model.Value1 != '' && model.Value1 != null">
                <img
                  :key="kindex"
                  :title="deiveStatusName(model.StatusType, model.Value1)"
                  class="link_img"
                  :src="
                    catchRequireErr(() =>
                      require('@static/device/statusinfo/' + model.StatusType + '/icon_' + model.StatusType + '_' + model.Value1 + '.png')
                    )
                  "
                >

                <!-- <img
													:key="kindex"
													:title="$t('devicecard.online')"
													v-if="model.Value1 == '0x0000'"
													class="link_img"
													src="../../assets/img/icon_type25.png"
												/>

												<img
                          :key="kindex"
                          :title="$t('devicecard.offline')"
                          v-else-if="model.Value1 == '0x0001'"
													class="link_img"
                          src="../../assets/img/icon_type26.png"
                        />

												<img
													:key="kindex"
													:title="$t('devicecard.callpolice')"
													v-else-if="model.Value1.substring(0, 4) == '0x01'"
													class="link_img"
													src="../../assets/img/icon_type02.png"
												/>
												<img
													:key="kindex"
													:title="$t('devicecard.malfunction')"
													v-else-if="model.Value1.substring(0, 4) == '0x02'"
													class="link_img"
													src="../../assets/img/icon_type01.png"
												/>
												<img
													:key="kindex"
													:title="$t('devicecard.lifeto')"
													v-else-if="model.Value1.substring(0, 4) == '0x03'"
													class="link_img"
													src="../../assets/img/icon_type03.png"
												/> -->
              </template>
              <template v-else>
                <img
                  v-if="!msg.IsOnline"
                  :key="kindex"
                  :title="$t('devicecard.offline')"
                  class="link_img"
                  src="../../assets/img/icon_type26.png"
                >
                <img
                  v-else
                  :key="kindex"
                  :title="$t('devicecard.online')"
                  class="link_img"
                  src="../../assets/img/icon_type25.png"
                >
              </template>
            </template>
            <template v-else-if="model.StatusType == '0x0100'">
              <img
                v-if="model.Value1 == 0"
                :key="kindex"
                :title="$t('devicecard.offline')"
                class="link_img"
                src="../../assets/img/icon_type26.png"
              >
              <img
                v-else
                :key="kindex"
                :title="$t('devicecard.online')"
                class="link_img"
                src="../../assets/img/icon_type25.png"
              >
            </template>
          </template>
          <!-- <img v-if="state == 4" class="link_img" src="../../assets/img/icon_type04.png" /> -->

          <!-- <i class="link_img icon-43" v-if="msg.StatusCode == '0x0000' && msg.IsOnline"></i>
									<i class="link_img icon-15" v-else-if="msg.StatusCode == '0x0000' && !msg.IsOnline"></i>
									<i class="link_img icon-15" v-else></i> -->
          <!-- 故障 -->
          <!-- <img class="link_img" v-if="msg.islink === true" src="../../assets/img/link.png" />
									<img class="link_img" v-else src="../../assets/img/nolink.png" /> -->
        </div>

        <div class="card_right op_relative">
          <div class="card_input op_cardname">
            <template v-if="msg.ChildId == 65535">
              <div v-show="!msg.flag" class="card_title op_static text-ellipsis" :title="msg.DeviceName">
                {{ msg.DeviceName }}
              </div>
              <input
                v-show="msg.flag"
                v-model="msg.DeviceName"
                type="text"
                class="op_w130 op_static"
                @blur="handleEnter"
                @keyup.enter="handleEnter"
                @click.stop="onStop"
              >
            </template>
            <template v-else>
              <div v-show="!msg.flag" class="card_title text-ellipsis op_static" :title="msg.ChildName + '-' + msg.DeviceName">
                {{ msg.ChildName }}-{{ msg.DeviceName }}
              </div>
              <input
                v-show="msg.flag"
                v-model="msg.ChildName"
                type="text"
                class="op_w130 op_static"
                @blur="handleEnter"
                @keyup.enter="handleEnter"
                @click.stop="onStop"
              >
            </template>
            <el-button
              v-if="!(extraProps.is_check || extraProps.noclick)"
              type="text"
              class="op_static"
              icon="el-icon-edit"
              @click.stop="edit"
            />
          </div>
        </div>
        <span v-if="msg.havecheck || msg.multipleDialogGroup" class="have_state">{{ $t('devicecard.alreadycheck') }}</span>
      </div>
    </div>

    <div class="card_msgs">
      <ul>
        <!-- <li>
							{{ $t('devicecard.attributes') }}：
							<span>{{ msg.IsBind == false ? $t('devicecard.nobind') + '-' : '' }}{{ msg.DeviceTypeName }}</span>
						</li>
						<li>
							MAC：
							<span>{{ macformate(msg.Mac) }}</span>
						</li> -->
        <li
          v-if="msg.Attach && msg.Attach.AreaNo !== undefined && msg.Attach.ClusterNo !== undefined"
          class="text-ellipsis" 
        >
          {{ $t('devicecard.area') }}
          <span>{{ msg.Attach.AreaNo || 0 }}</span>
          <span>{{ `   ` }}</span>
          {{ $t('findDevice.group') }}
          <span>{{ msg.Attach.ClusterNo || 0 }}</span>
        </li>
        <li
          v-else 
          class="text-ellipsis"
          :title="msg.ParentAreaNames"
        >
          {{ $t('devicecard.area') }}：
          <span>{{ msg.ParentAreaNames != null ? msg.ParentAreaNames : getParentAreaNames(msg.ParentGpnos, msg, 'ParentAreaNames') }}</span>
        </li>
      </ul>

      <div v-if="false" class="have_date">
        <el-tooltip
          class="item"
          effect="light"
          :content="$t('devicecard.dataing')"
          placement="bottom"
        >
          <!-- <img src="../../assets/img/date.png" /> -->
          <i class="icon-18" />
        </el-tooltip>
      </div>
      <div class="have_new">
        <distinguish :msg="msg" class="findDevice-inif" @socket-handler="functionScoketsync_info_event" />
      </div>
    </div>
  </div>
</template>
<script>
import Distinguish from '@/components/button/Distinguish'
import { catchRequireErr, getImgUrlState } from '@/utils/utils'
export default {
  components: {
    Distinguish,
  },
  props: {
    source: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
    extraProps: {
      type: Object,
      default: () => {}, //额外的参数
    },
  },
  data() {
    return {
      msg: this.source,
      getImgUrlState,
    }
  },
  watch: {
    source: {
      handler(val) {
        this.msg = val
      },
      deep: true,
    },
  },
  created() {
    this.doParentGpnos()
  },
  methods: {
    catchRequireErr,
    cardset() {
      this.extraProps.cardset && this.extraProps.cardset(this.msg)
    },
    /**
     * 分解原始数据字段 doParentGpnos
     */
    doParentGpnos() {
      if (typeof this.msg['ParentGpnos'] == 'string') {
        //会归入父级所涉及区域
        var _ParentGpnos = this.msg['ParentGpnos']
        _ParentGpnos = _ParentGpnos && _ParentGpnos.replace(/@/g, '')
        _ParentGpnos = _ParentGpnos && _ParentGpnos.split(',')
        if (_ParentGpnos instanceof Array) {
          // eslint-disable-next-line vue/no-mutating-props
          this.msg['_ParentGpnos'] = _ParentGpnos.reverse()
        }
      }
    },
    removeTree() {
      this.extraProps.removeTree && this.extraProps.removeTree(this.msg)
    },
    handleEnter() {
      this.extraProps.handleEnter && this.extraProps.handleEnter(this.msg)
    },
    onStop() {
      this.extraProps.onStop && this.extraProps.onStop()
    },
    edit() {
      this.extraProps.edit && this.extraProps.edit(this.msg)
    },
    getParentAreaNames(...arg) {
      return this.extraProps.getParentAreaNames && this.extraProps.getParentAreaNames(...arg)
    },
    functionScoketsync_info_event(rs) {
      this.$emit('functionScoketsync_info_event', rs)
    },
  },
}
</script>
<style lang="scss" scoped>
/* 设备卡片样式	 */
// .card_list:hover{
//   border: solid 1px #dde8f7;
//   border-radius: 20px;
// }
.op_relative {
  position: relative;
}
.op_mt40 {
  margin-top: 36px;
}
.op_w130 {
  width: 130px;
}
.op_cardname {
  display: flex;
  left: 0px;
  align-items: center;
  justify-content: center;
  position: absolute !important;
  width: auto !important;
  max-width: 160px !important;
}
.text-ellipsis,
.text-ellipsis div {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.op_static {
  position: static !important;
}
.card_list {
  display: inline-block;
  cursor: pointer;
  border-radius: 3px;
  position: relative;
  // -webkit-transition: all 1s;
  // transition: all 1s;
  &.hiden {
    //display: none;
    pointer-events: none;  // 禁止鼠标事件
    opacity: 0.6;          // 可选，加点透明度，表示禁用状态
    cursor: not-allowed;   // 可选，鼠标样式变成禁止
  }
  .card_header {
    /*border-radius: 3px 3px 0px 0px;*/
    height: 108px;
    margin-bottom: 10px;
    position: relative;
    .multipleCheck {
      color: #ff0000;
      font-size: 10px;
      position: absolute;
      right: 25px;
      top: 5px;
      z-index: 100;
    }
    .card_badge {
      position: relative;
      width: 40px;
      height: 40px;
      z-index: 1;
      i {
        position: absolute;
        z-index: 1;
        color: #fff;
        width: 31px;
        height: 40px;
        left: 9px;
        top: 4px;
        text-align: center;
        -webkit-transform: rotate(-45deg);
        -moz-transform: rotate(-45deg);
        -ms-transform: rotate(-45deg);
        -o-transform: rotate(-45deg);

        filter: progid:DXImageTransform.Microsoft.BasicImage(Rotation=0.45);
        font-size: 11px;
        font-style: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      &:after {
        position: absolute;
        content: '';
        width: 0px;
        height: 0px;
        border-color: transparent thistle;
        border-width: 0px 0px 40px 40px;
        border-style: solid;
        left: 0px;
        top: 0px;
      }
    }
    .bgcolor1 {
      &:after {
        border-color: transparent #a39ce2;
      }
    }
    .bgcolor2 {
      &:after {
        border-color: transparent #92a1e4;
      }
    }
    .bgcolor3 {
      &:after {
        border-color: transparent #97b0d4;
      }
    }
    .bgcolor4 {
      &:after {
        border-color: transparent #a2c0c8;
      }
    }
    .bgcolor5 {
      &:after {
        border-color: transparent #92a1e4;
      }
    }
    .bgcolor6 {
      &:after {
        border-color: transparent #a2acc8;
      }
    }
    .bgcolor7 {
      &:after {
        border-color: transparent #a2bcc8;
      }
    }
  }
}
.card_header_msg {
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  .card_left {
    width: 35%;
    display: inline-block;
    box-sizing: border-box;
    float: left;
    position: relative;
    height: 100%;
    .card_img {
      height: 40px;
      display: block;
      margin: 0 auto;
      margin-top: 35px;
    }
    .link_img {
      position: absolute;
      left: 16px;
      bottom: 8px;
    }
  }
  .card_right {
    color: $color6;
    display: inline-block;
    width: 65%;
    box-sizing: border-box;
    margin-top: 13px;
    .card_title {
      // width: 100%;
      line-height: 35px;
    }
    li {
      width: 50%;
      display: inline-block;
      float: left;
      height: 20px;
      margin-bottom: 8px;
      span {
        color: $color5;
      }
      button {
        width: 40px;
        height: 18px;
        border-radius: 3px;
        border: solid 1px $color6;
        line-height: 18px;
        padding: 0px;
        color: $color6;
        background: transparent;
        span {
          color: $color6;
        }
      }
    }
  }
  .have_state{
    top: 2px;
    right: 14px;
    transform: scale(0.8);
  }
}
.real {
  background: linear-gradient(-45deg, #dbe6fe, #e9f1ff);
}
.fake {
  background: linear-gradient(-45deg, #dbe9fa, #ebf4ff);
}

.card_input {
  font-size: 12px;
  color: $color6;
  position: relative;
  width: 100px;
  height: 25px;
  margin-bottom: 10px;
  button {
    margin-left: 5px;
  }
  input {
    display: inline-block;
    border: 1px solid $color6;
    background: transparent;
    height: 100%;
    color: $color6;
    position: absolute;
    width: 100%;
    text-indent: 10px;
    font-size: 12px;
    border-radius: 3px;
    outline: none;
  }
}
.have_date {
  position: absolute;
  top: 5px;
  right: 15px;
}
.have_new {
  position: relative;
  img {
    position: absolute;
    right: 0px;
    top: -20px;
  }
  button {
    width: 100%;
    height: 30px;
    border-radius: 3px;
    border: solid 1px #ced3db;
    font-size: 13px;
    background: #fff;
    color: #8a94a4;
    cursor: pointer;
    &:hover {
      color: #409eff;
      border-color: #c6e2ff;
      background-color: #ecf5ff;
    }
  }
}
.card_list {
  .shadow_box {
    position: absolute;
    width: 100%;
    height: 100%;
  }
}
.icon-43 {
  color: #6fa2ea;
  font-size: 16px;
}
.icon-15 {
  font-size: 18px;
  color: #a8b9d1;
}
.icon-45 {
  color: #2481ea;
  font-size: 14px;
}
.icon-37 {
  color: #2481ea;
  font-size: 14px;
}
.icon--96 {
  color: #2481ea;
  font-size: 14px;
}
.icon-18 {
  font-size: 18px;
  color: #ff5952;
}

.card_list_small {
  width: 169px !important;
  height: 144px !important;
  .card_header {
    height: 64.5px;
    .card_left {
      width: 100%;
      .card_img {
        margin-top: 20px;
      }
      .link_img {
        display: none !important;
      }
    }
    .card_right.op_relative {
      width: 100%;
      height: 20px;
      margin-top: 0px;
      text-align: center;
      .card_input.op_cardname {
        width: 100% !important;
        max-width: 100% !important;
        height: auto;
      }
    }
  }
  .card_state.op_mt40 {
    display: none !important;
  }
  .card_msgs {
    padding-top: 23px;
    ul li {
      margin-bottom: 7px;
    }
    .have_new button {
      height: 20px;
      line-height: 20px;
      padding: 0;
    }
  }
  &:hover {
    .card_header {
      .card_right.op_relative {
        position: absolute;
        top: 30px;
        left: 0;
        background: white;
        height: inherit;
        .card_input.op_cardname {
          .card_title.op_static.text-ellipsis {
            /*
            white-space: normal;
            line-height: 20px;
            height: 40px;
            */
            display: flex;
            justify-content: center;
            align-items: flex-end;
            align-content: flex-end;
            height: 48px;
            line-height: 20px;
            white-space: normal !important;
          }
        }
      }
    }
    .card_msgs {
      padding-top: 8px;
      ul li.text-ellipsis {
        height: 27px;
        line-height: 14px;
        span {
          white-space: normal;
        }
      }
    }
  }
}
.Ble_signal_pic {
  margin-right: 4px;
  width: 14px;
  height: 14px;
}
</style>

<style>
.findDevice-inif .el-button {
  height: 20px;
  font-size: 12px;
  line-height: 1px;
}
</style>
